import { X, Store, ShoppingBag } from 'lucide-react';

interface AppDownloadPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function AppDownloadPopup({ isOpen, onClose }: AppDownloadPopupProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      <div className="relative bg-gradient-to-br from-purple-900 to-gray-900 rounded-2xl p-8 max-w-md w-full shadow-2xl animate-slideIn">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center space-y-6">
          <div className="flex justify-center mb-4">
            <img
              src="https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&q=80"
              alt="Mobile App"
              className="w-32 h-32 rounded-xl object-cover"
            />
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-white mb-2">Download Our App</h3>
            <p className="text-purple-200">
              Take your learning journey anywhere with our mobile app. Available for iOS and Android devices.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              className="group relative inline-flex items-center justify-center bg-black hover:bg-gray-900 text-white font-semibold px-6 py-3 rounded-lg transition-all overflow-hidden flex-1"
            >
              <div className="absolute inset-0 w-3 bg-gradient-to-r from-purple-400 to-pink-400 transition-all duration-[400ms] ease-out group-hover:w-full opacity-40"></div>
              <div className="relative flex items-center gap-3">
                <Store className="w-6 h-6" />
                <div className="flex flex-col items-start">
                  <span className="text-xs opacity-80">Download on the</span>
                  <span className="text-sm font-bold">App Store</span>
                </div>
              </div>
            </button>

            <button 
              className="group relative inline-flex items-center justify-center bg-black hover:bg-gray-900 text-white font-semibold px-6 py-3 rounded-lg transition-all overflow-hidden flex-1"
            >
              <div className="absolute inset-0 w-3 bg-gradient-to-r from-green-400 to-emerald-400 transition-all duration-[400ms] ease-out group-hover:w-full opacity-40"></div>
              <div className="relative flex items-center gap-3">
                <ShoppingBag className="w-6 h-6" />
                <div className="flex flex-col items-start">
                  <span className="text-xs opacity-80">GET IT ON</span>
                  <span className="text-sm font-bold">Google Play</span>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}